const E = "link", R = {
  ALTERNATE: "alternate",
  AUTHOR: "author",
  BOOKMARK: "bookmark",
  EXTERNAL: "external",
  HELP: "help",
  LICENSE: "license",
  NEXT: "next",
  NOFOLLOW: "nofollow",
  NOREFERRER: "noreferrer",
  NOOPENER: "noopener",
  PREV: "prev",
  SEARCH: "search",
  TAG: "tag"
}, r = {
  BLANK: "_blank",
  PARENT: "_parent",
  SELF: "_self",
  TOP: "_top"
}, e = {
  CLEAR: "clear",
  UNDERLINED: "underlined"
}, N = {
  NO_REFERRER: "no-referrer",
  NO_REFERRER_WHEN_DOWNGRADE: "no-referrer-when-downgrade",
  ORIGIN: "origin",
  ORIGIN_WHEN_CROSS_ORIGIN: "origin-when-cross-origin",
  SAME_ORIGIN: "same-origin",
  STRICT_ORIGIN_WHEN_CROSS_ORIGIN: "strict-origin-when-cross-origin",
  UNSAFE_URL: "unsafe-url"
};
export {
  E as LINK_BASE_CLASS,
  N as LINK_REFFERRER_POLICIES,
  R as LINK_RELATIONSHIPS,
  r as LINK_TARGETS,
  e as LINK_TYPES
};
